// extracted by mini-css-extract-plugin
var _1 = "OtherSettings_delimiter__25da8";
var _2 = "OtherSettings_label__01bae";
var _3 = "OtherSettings_list__62df0";
var _4 = "OtherSettings_titleList__8cefc";
export { _1 as "delimiter", _2 as "label", _3 as "list", _4 as "titleList" }
